import { WHATSAPP_TEMPLATES_PAGE_KEY } from './constants';

export const es = {
  [WHATSAPP_TEMPLATES_PAGE_KEY]: {
    TABLE_TITLE: 'Plantillas de WhatsApp',
    CREATE_TEMPLATE_BUTTON: 'Crear plantilla',

    COLUMN_ALIAS: 'Alias',

    COLUMN_SLUG: 'Slug',
    COLUMN_DESCRIPTION: 'Descripción',
    COLUMN_META_NAME: 'Nombre en WhatsApp',
    COLUMN_LANGUAGE: 'Idioma',
    COLUMN_META_TEMPLATE_ID: 'ID de WhatsApp',
    COLUMN_META_STATUS: 'Estado en WhatsApp',
    COLUMN_CATEGORY: 'Categoría',
    COLUMN_PLACEHOLDERS: 'Variables',
    COLUMN_MAPPING: 'Mapeo',
    COLUMN_LAST_SYNC: 'Última sincronización',

    LEGEND_LOCK_LABEL: 'Viene de WhatsApp, solo lectura',
    LEGEND_PENCIL_LABEL: 'Lo administra Crehana',

    NOTICE_BAND_TEXT:
      'Las plantillas se crean y se aprueban en WhatsApp Manager. Aquí se importan de solo lectura.',
    NOTICE_BAND_LINK: 'Abrir WhatsApp Manager',

    PRODUCT_SELECTOR_LABEL: 'Producto',
    PRODUCT_SELECTOR_ACCOUNT_LABEL: 'Cuenta de WhatsApp en uso',
    PRODUCT_UNAVAILABLE_TAG: 'Próximamente',
    PRODUCT_RECRUITMENT: 'Reclutamiento',
    PRODUCT_ENGAGEMENT: 'Compromiso',
    PRODUCT_LEARNING: 'Aprendizaje',
    PRODUCT_PAYROLL: 'Planilla',
    PRODUCT_PERFORMANCE: 'Desempeño',
    PRODUCT_PERSONAS_HRIS: 'Personas HRIS',

    SEARCH_PLACEHOLDER: 'Buscar por alias o nombre en WhatsApp',
    FILTER_META_STATUS_LABEL: 'Estado en WhatsApp',
    FILTER_META_STATUS_ALL_OPTION: 'Todos',
    FILTER_INCOMPLETE_LABEL: 'Mapeo incompleto',
    PAGE_SIZE_LABEL: 'Filas por página',
    PAGINATION_SUMMARY: '{{from}}–{{to}} de {{total}}',
    FILTER_META_STATUS_CLEAR: 'Quitar el filtro de estado',
    SORT_BY: 'Ordenar por {{column}}',
    SORT_ASCENDING: 'Orden ascendente',
    SORT_DESCENDING: 'Orden descendente',
    PAGINATION_LABEL: 'Paginación',
    PAGINATION_PREVIOUS: 'Página anterior',
    PAGINATION_NEXT: 'Página siguiente',
    PAGINATION_PAGE: 'Página {{page}}',
    PAGINATION_PAGE_OF: 'Página {{page}} de {{total}}',
    PAGINATION_OF_TOTAL: 'de {{total}}',
    COLUMN_ACTIONS: 'Acciones',
    NO_RESULTS_SEARCH_TITLE: 'No se encontraron resultados para',
    NO_RESULTS_SEARCH_DESCRIPTION:
      'Inténtalo de nuevo con un término diferente.',
    NO_RESULTS_FILTERS_TITLE: 'No hay resultados para mostrar',
    NO_RESULTS_FILTERS_DESCRIPTION:
      'Inténtalo de nuevo con un filtro diferente.',

    INCOMPLETE_MAPPING_COUNTER: '{{count}} plantillas con el mapeo incompleto',

    LAST_SYNC_LABEL: 'Última sincronización: {{date}}',
    SYNC_ACTION_LABEL: 'Sincronizar',
    SYNC_ACTION_SYNCING_LABEL: 'Sincronizando...',
    SYNC_META_UNAVAILABLE_NOTICE:
      'WhatsApp no respondió. Se muestran las plantillas de la última sincronización.',
    LAST_SYNC_NEVER: 'Última sincronización: sin datos',
    SYNC_TOAST_TITLE: 'Plantillas sincronizadas con WhatsApp',
    SYNC_TOAST_DESCRIPTION:
      '{{updated}} actualizadas · {{unchanged}} sin cambios · {{missing}} ya no están en WhatsApp · {{outdated}} con el mapeo desactualizado',
    SYNC_ERROR_TITLE: 'No se pudo sincronizar con WhatsApp',
    SYNC_ERROR_META_NOT_CONFIGURED:
      'Este entorno no tiene configurada la conexión con WhatsApp.',
    SYNC_ERROR_META_ACCESS_DENIED:
      'WhatsApp rechazó el acceso de Crehana a sus plantillas.',
    SYNC_ERROR_META_UNAVAILABLE:
      'WhatsApp no respondió. Vuelve a intentarlo en unos minutos.',
    SYNC_ERROR_GENERIC: 'Vuelve a intentarlo.',
    SYNC_RESULT_TITLE: 'Revisa estas plantillas',
    SYNC_RESULT_MISSING: 'Ya no están en WhatsApp: {{slugs}}',
    SYNC_RESULT_OUTDATED:
      'Su mensaje cambió en WhatsApp. Edita su mapeo antes del próximo envío: {{slugs}}',

    ROW_MENU_TRIGGER_LABEL: 'Más acciones',
    ROW_MENU_VIEW: 'Ver',
    ROW_MENU_EDIT: 'Editar',
    ROW_MENU_REMOVE: 'Quitar del registro',

    PREVIEW_DIALOG_TITLE: 'Vista previa de la plantilla',
    PREVIEW_DIALOG_MESSAGE_LABEL: 'Mensaje',
    PREVIEW_DIALOG_PLACEHOLDERS_LABEL: 'Variables',
    PREVIEW_DIALOG_PLACEHOLDER_EXAMPLE_LABEL: 'Ejemplo',
    PREVIEW_DIALOG_CLOSE: 'Cerrar',

    REMOVE_DIALOG_TITLE: 'Quitar del registro',
    REMOVE_DIALOG_DESCRIPTION:
      'La plantilla sigue en WhatsApp. Solo se quita del registro de Crehana.',
    REMOVE_DIALOG_DETAIL:
      '«{{alias}}» ({{slug}}) sale del registro y ya no se puede enviar. En WhatsApp no cambia nada.',
    REMOVE_DIALOG_USED_BY_PRODUCT: 'La usa el producto {{product}}.',
    REMOVE_DIALOG_CONFIRM: 'Quitar',
    REMOVE_DIALOG_CANCEL: 'Cancelar',
    REMOVE_TOAST_DONE: 'Plantilla quitada del registro. Slug: {{slug}}',
    REMOVE_TOAST_ERROR: 'No se pudo quitar la plantilla',
    REMOVE_TOAST_ERROR_DESCRIPTION: 'Vuelve a intentarlo.',

    EMPTY_STATE_TITLE: 'Todavía no hay plantillas registradas',
    EMPTY_STATE_DESCRIPTION:
      'Las plantillas se crean en WhatsApp Manager. Impórtalas para verlas aquí.',

    ERROR_STATE_TITLE: 'No se pudieron cargar las plantillas',
    ERROR_STATE_DESCRIPTION:
      'Ocurrió un error al cargar las plantillas de WhatsApp.',
    ERROR_STATE_RETRY: 'Reintentar',

    META_STATUS_APPROVED: 'Aprobada',
    META_STATUS_PENDING: 'Pendiente',
    META_STATUS_REJECTED: 'Rechazada',
    META_STATUS_PAUSED: 'Pausada',

    CATEGORY_MARKETING: 'Marketing',
    CATEGORY_UTILITY: 'Utilidad',
    CATEGORY_AUTHENTICATION: 'Autenticación',

    PLACEHOLDER_FORMAT_NAMED: 'Con nombre',
    PLACEHOLDER_FORMAT_POSITIONAL: 'Posicional',

    MAPPING_STATUS: '{{mapped}}/{{total}}',

    ROUTE_LOADING_LABEL: 'Cargando la página',

    SEND_TEST_BUTTON: 'Probar envío',
    SEND_TEST_DISABLED_NO_TEMPLATES:
      'Este producto no tiene plantillas. Importa una plantilla para probar un envío.',
    SEND_TEST_TITLE: 'Probar envío de WhatsApp',
    SEND_TEST_DESCRIPTION:
      'Envía un mensaje real con send_whatsapp, la misma operación que usan los productos. Cada destinatario recibe el mensaje.',
    SEND_TEST_CLOSE: 'Cerrar',
    SEND_TEST_TEMPLATE_LABEL: 'Plantilla (template_slug)',
    SEND_TEST_TEMPLATE_PLACEHOLDER: 'Elige una plantilla',
    SEND_TEST_TEMPLATE_OPTION: '{{alias}} · {{slug}}',
    SEND_TEST_ORGANIZATION_LABEL:
      'ID de organización (centralized_organization_id)',
    SEND_TEST_VARIABLES_TITLE: 'Variables (variables)',
    SEND_TEST_VARIABLES_CHOOSE_TEMPLATE:
      'Elige una plantilla para ver sus variables.',
    SEND_TEST_VARIABLES_NONE:
      'Esta plantilla no necesita variables del producto.',
    SEND_TEST_VARIABLES_DESCRIPTION: 'Valores para todos los destinatarios.',
    SEND_TEST_VARIABLE_REQUIRED: '{{key}} (obligatoria)',
    SEND_TEST_PROFILE_VARIABLES:
      'Del perfil del destinatario: {{keys}}. El destinatario debe ser miembro de la organización.',
    SEND_TEST_RECIPIENTS_TITLE: 'Destinatarios (recipients)',
    SEND_TEST_RECIPIENT_TITLE: 'Destinatario {{index}}',
    SEND_TEST_RECIPIENT_ADD: 'Agregar destinatario',
    SEND_TEST_RECIPIENT_REMOVE: 'Quitar destinatario {{index}}',
    SEND_TEST_USER_ID_LABEL: 'ID de usuario (centralized_user_id)',
    SEND_TEST_PHONE_LABEL: 'Teléfono (phone)',
    SEND_TEST_PHONE_PLACEHOLDER: '+51987654321',
    SEND_TEST_COUNTRY_LABEL: 'País (country_iso_code)',
    SEND_TEST_COUNTRY_PLACEHOLDER: 'PE',
    SEND_TEST_OVERRIDES_TRIGGER: 'Variables solo para este destinatario',
    SEND_TEST_OVERRIDES_DESCRIPTION:
      'Opcional. Un valor aquí reemplaza el valor común para este destinatario.',
    SEND_TEST_SOURCE_TITLE: 'Origen (source)',
    SEND_TEST_SOURCE_DESCRIPTION:
      'Opcional. Si completas target_type o target_id, completa también app_name.',
    SEND_TEST_APP_NAME_LABEL: 'app_name',
    SEND_TEST_TARGET_TYPE_LABEL: 'target_type',
    SEND_TEST_TARGET_ID_LABEL: 'target_id',
    SEND_TEST_CANCEL: 'Cancelar',
    SEND_TEST_SUBMIT: 'Enviar',
    SEND_TEST_TOAST_TITLE: 'Envío en cola',
    SEND_TEST_TOAST_DESCRIPTION:
      'ID: {{sendId}} · Estado: {{status}} · Destinatarios: {{count}}',
    SEND_TEST_ERROR_TITLE: 'El envío no se hizo',
    SEND_TEST_ERROR_NETWORK: 'No hubo respuesta del servidor.',
    SEND_TEST_ERROR_ISSUE: '{{code}}: {{message}}',
    SEND_TEST_ERROR_ISSUE_FIELD: '{{code}} · {{field}}: {{message}}',
    SEND_TEST_ERROR_REQUIRED: 'Completa este campo.',
    SEND_TEST_ERROR_INTEGER: 'Escribe solo números.',
    SEND_TEST_ERROR_PHONE:
      'Escribe el número con + y el código de país, por ejemplo +51987654321.',
    SEND_TEST_ERROR_RECIPIENTS_MIN: 'Agrega al menos un destinatario.',
    SEND_TEST_ERROR_RECIPIENTS_MAX:
      'Envía a {{max}} destinatarios como máximo.',
    SEND_TEST_ERROR_MAX_LENGTH: 'Escribe {{max}} caracteres como máximo.',
    SEND_TEST_ERROR_APP_NAME_REQUIRED:
      'Completa app_name cuando envías target_type o target_id.',
    SEND_TEST_ERROR_VARIABLE_REQUIRED:
      'Completa este valor aquí o en cada destinatario.',
  },
};
